import { render } from "./spinner.vue?vue&type=template&id=2d5117f6"
const script = {}

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__